<template>
      <dropdown :options="arrayOfObjects" :selected="object" v-on:updateOption="methodToRunOnSelect">
        <slot></slot>
      </dropdown>
</template>
<script>
import dropdown from 'vue-dropdowns'
export default {
  components: {
    'dropdown': dropdown
  },
  data () {
    return {
      arrayOfObjects: [],
      object: {
        name: 'Object Name'
      }
    }
  },
  methods: {
    methodToRunOnSelect (payload) {
      this.object = payload
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/partials/Menus/dropdown.vue